import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1afcd828"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "approval" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank spacing" }, "审批流程", -1))
const _hoisted_3 = { class: "jindu block-box" }
const _hoisted_4 = { class: "block-con" }
const _hoisted_5 = { class: "jindu-item" }
const _hoisted_6 = { class: "pic" }
const _hoisted_7 = { class: "rbox" }
const _hoisted_8 = { class: "tit" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = { class: "time" }

import { flowsItem } from '@/apis/base'
import { watch, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: ['flows'],
  setup(__props) {

const props = __props


const details = ref([] as Array<flowsItem>)
watch(props, v => {
  details.value = v.flows
  // console.log('watch=====details>', details.value[details.value.length - 1].state == 0)
})

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_steps, {
          direction: "vertical",
          "active-color": details.value[details.value.length - 1]?.state == 2 ? '#D43030' : details.value[details.value.length - 1]?.state == 3 ? '#A1A1A1' : '',
          "active-icon": details.value[details.value.length - 1]?.state == 2 ? 'clear' : 'checked',
          active: details.value[details.value.length - 1]?.state == 0 ? details.value.length - 2 : details.value.length - 1
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(details.value, (e, i) => {
              return (_openBlock(), _createBlock(_component_van_step, { key: i }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_van_image, {
                        round: "",
                        width: "50",
                        height: "50",
                        src: e.staff_avatar
                      }, null, 8, ["src"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", null, _toDisplayString(e.state_name), 1),
                        _hoisted_9,
                        _createElementVNode("span", _hoisted_10, _toDisplayString(e.time), 1)
                      ]),
                      _createElementVNode("div", null, _toDisplayString(e.staff_name), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["active-color", "active-icon", "active"])
      ])
    ])
  ]))
}
}

})